import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const RecordedIcon = React.memo(
  ({ fill = variables['colors-mc-primary'], width = 54, viewBox = '0 0 54 54' }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(width)}
      viewBox={viewBox}
    >
      <g id='Group_3947' data-name='Group 3947' transform='translate(-361.173 -843.172)'>
        <g id='Group_2096' data-name='Group 2096' transform='translate(361.36 843.36)'>
          <circle
            id='Ellipse_165'
            data-name='Ellipse 165'
            cx='27'
            cy='27'
            r='27'
            transform='translate(-0.187 -0.188)'
            fill={fill}
          />
        </g>
        <g id='Group_2095' data-name='Group 2095' transform='translate(377.447 859.447)'>
          <g
            id='Rectangle_1385'
            data-name='Rectangle 1385'
            transform='translate(-0.275 -0.275)'
            fill='#fff'
            stroke='#fff'
            strokeWidth='1'
          >
            <rect width='22' height='22' rx='3' stroke='none' />
            <rect x='0.5' y='0.5' width='21' height='21' rx='2.5' fill='none' />
          </g>
          <rect
            id='Rectangle_1386'
            data-name='Rectangle 1386'
            width='8.956'
            height='8.956'
            rx='4.478'
            transform='translate(6.247 6.247)'
            fill={fill}
          />
        </g>
      </g>
    </svg>
  )
);
RecordedIcon.displayName = 'RecordedIcon';

export default RecordedIcon;
